import { injectScriptTag } from 'utils/injectScriptTag';
import { TRecaptchaApi } from 'types/services';
import { GOOGLE_RECAPTCHA_KEY } from 'utils/constants';
import { CaptchaError } from 'utils/errors';

const destroy = () => {
  const scripts = document.getElementsByTagName('script');
  for (const script of Array.from(scripts)) {
    const src = script.getAttribute('src');
    if (src && script.parentNode && src.includes('recaptcha')) {
      script.parentNode.removeChild(script);
    }
  }
  const badge = document.getElementsByClassName('grecaptcha-badge')[0];
  if (badge && badge.parentNode) {
    const badgeNode = badge.parentNode as HTMLDivElement;
    badgeNode.remove();
  }
};

export const initRecaptcha = (): Promise<TRecaptchaApi> => {
  return new Promise(async (resolve, reject) => {
    const recaptchaUrl = `https://www.google.com/recaptcha/api.js?render=${GOOGLE_RECAPTCHA_KEY}`;

    try {
      await injectScriptTag(recaptchaUrl);

      window.grecaptcha.ready(() => {
        resolve({ destroy });
      });
    } catch (error) {
      throw new CaptchaError();
    }
  });
};
